import React , {Component } from 'react';
import Client from '../Sections/Client';
import Faq from '../Sections/Faq';
import { Link } from 'react-router-dom';
import AUX from '../../hoc/Aux_';
import { connect } from 'react-redux';
import * as actionTypes from '../../store/action';
import Modal from "react-responsive-modal";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';
import { fade, makeStyles, withStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import Collapse from '@material-ui/core/Collapse';
import { useSpring, animated } from 'react-spring/web.cjs';
import { Alert, AlertTitle } from '@material-ui/lab';
import CloudDownload from '@material-ui/icons/CloudDownload';
import CloseIcon from '@material-ui/icons/Close';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogDetail from '../../components/Kugi/dialogdetail';
import IconButton from '@material-ui/core/IconButton';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {fetchKategori, fetchUnsur, fetchUnsurDetail } from '../../api/kugi';
import {pushCategory, pushUnsur, pushSelectedUnsur} from '../../actions/general';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import _ from 'lodash';
import TablePropertyType from '../../components/Kugi/tablePropertyType'
import Services from '../MainContent/Sections/Services';
import Features from '../MainContent/Sections/Features';
import Counter from '../MainContent/Sections/Counter';
import Pricing from '../MainContent/Sections/Pricing';
import BorderColor from '@material-ui/icons/BorderColor';
import Config from "../../config/";
import Kugicatdetail from "./Kugicatdetail";
import FolderOpen from '@material-ui/icons/FolderOpen';
import Folder from '@material-ui/icons/Folder';

import { css } from "@emotion/core";
import {BarLoader} from "react-spinners";

const ROOT_URL = Config.rooturl;
const override = css`
position: absolute;
  top: 50%;
  left: 45%;
  margin: 0 auto;
`;

const StyledTreeItem = withStyles(theme => ({
  iconContainer: {
    '& .close': {
      opacity: 0.3,
    },
  },
  group: {
    marginLeft: 12,
    paddingLeft: 12,
    borderLeft: `1px dashed ${fade(theme.palette.text.primary, 0.4)}`,
  },
}))(props => <TreeItem {...props} TransitionComponent={TransitionComponent} />);

function TransitionComponent(props) {
  const style = useSpring({
    from: { opacity: 0, transform: 'translate3d(20px,0,0)' },
    to: { opacity: props.in ? 1 : 0, transform: `translate3d(${props.in ? 0 : 20}px,0,0)` },
  });

  return (
    <animated.div style={style}>
      <Collapse {...props} />
    </animated.div>
  );
}

class Kugi extends Component{

    constructor(props) {
      super(props);
      this.state = {
        open: false,
        openCat: false,
        catSelected: 1,
        catSelectedName: '',
        category: [],
        unsur: [],
        expanded: ['2'],
        unsurSelected: null,
        unsurSelectedVal: [],
        catid: 0,
        unsurDetail:[],
        ftid: "",
        ftidAct: false,
        ftcode: "",

        featureTypeID:"",
        code:"",
        typeName:"",
        attribute_is_abstract:"",
        bf_attribute:"",
        date:"",
        definition:"",
        featureCatalogue:"",
        featureCatalogueId:"",
        definition:"",
        aliases:"",
        fcDefinitionSource:"",
        inheritanceSubtype:"",
        inheritanceSupertype:"",
        inheritanceDescription:"",
        inheritanceName:"",
        fcDefinitionReference:"",
        attributeIsAbstract:"",
        fcConstraint:"",
        fcFeatureAssociation:"",
        feature_catalogue:"",
        fcAssociationRole:"",
        fcFeatureOperation:"",
        date:"",
        attributVersionNumber:"",
        fcProducer:"",
        role:"",
        faCode:"",
        faValueMeasurementUnit:"",
        faValueType:"",
        fcDefinitionReference1:"",
        fcProducer1:"",
        bfAtribute:"",

        loading: true

      };
    }

    componentWillMount(){
      fetchKategori()
        .then(response => {
          let a = _.orderBy(response.data, 'name','asc');

          console.log(a);
          this.props.pushCategory(a);
          this.setState({ loading: false });
        })
        .catch(error => {
          console.log(error);
        });
    }

    handleClose = () => {
      this.setState({ open: false });
    }
    handleCloseCat = () => {
      this.setState({ openCat: false });
    }

    getUnsurDetail = (e)=>{

      this.props.pushSelectedUnsur(e.replace("@en", ""));

      var a = _.find(this.props.unsur, { 'featureTypeID': e+"@en"});

        this.setState({open: true})

        this.setState({featureTypeID: a.featureTypeID.replace("@en", "")});
        this.setState({code: a.code.replace("@en", "")});
        this.setState({typeName: a.typeName.replace("@en", "")});
        this.setState({featureCatalogue: a.featureCatalogue.replace("@en", "")});
        this.setState({definition: a.definition.replace("@en", "")});
        this.setState({aliases: a.aliases.replace("@en", "")});
        this.setState({fcDefinitionSource: a.fcDefinitionSource.replace("@en", "")});
        this.setState({inheritanceSubtype: a.inheritanceSubtype.replace("@en", "")});
        this.setState({inheritanceSupertype: a.inheritanceSupertype.replace("@en", "")});
        this.setState({faCoinheritanceDescriptionde: a.inheritanceDescription.replace("@en", "")});
        this.setState({inheritanceName: a.inheritanceName.replace("@en", "")});
        this.setState({fcName: a.fcName.replace("@en", "")});
        this.setState({fcDefinitionReference: a.fcDefinitionReference.replace("@en", "")});
        this.setState({attributeIsAbstract: a.attributeIsAbstract.replace("@en", "")});

        this.setState({fcFeatureAssociation: a.fcFeatureAssociation.replace("@en", "")});
        this.setState({fcAssociationRole: a.fcAssociationRole.replace("@en", "")});
        this.setState({fcFeatureOperation: a.fcFeatureOperation.replace("@en", "")});
        this.setState({date: a.date.replace("@en", "")});
        this.setState({attributVersionNumber: a.attributVersionNumber.replace("@en", "")});
        this.setState({fcProducer: a.fcProducer.replace("@en", "")});
        this.setState({role: a.role.replace("@en", "")});

    }

    renderUnsur = (e) =>{

      let slicecode = this.state.ftcode.slice(6,10);
      let slicecode2 = e.code.replace("@en", "").slice(6,10);

      if(slicecode != slicecode2){
        return false;
      }

      let code = e.code.replace("@en", "");

      let a = code.slice(4, 6);
      let skala = ''

      switch (a){
        case "01":
        skala = "1:1.000.000"
        break;
        case "02":
        skala = "1:500.000"
        break;
        case "03":
        skala = "1:250.000"
        break;
        case "04":
        skala = "1:100.000"
        break;
        case "05":
        skala = "1:50.000"
        break;
        case "06":
        skala = "1:25.000"
        break;
        case "07":
        skala = "1:10.000"
        break;
        case "08":
        skala = "1:5.000"
        break;
        case "09":
        skala = "1:2.500"
        break;
        case "10":
        skala = "1:1.000"
        break;
      }
      return (
        <StyledTreeItem
          nodeId={e.featureTypeID.replace("@en", "")}
          label={e.typeName.replace("@en", "") + " (" +skala+")" }
          onClick={()=>{this.getUnsurDetail(e.featureTypeID.replace("@en", ""))}}
        />
      )
      //return (<StyledTreeItem nodeId="6" label="Hello" />)
    }

    getUnsur = (e)=>{

      if(this.state.catid == e){
        this.setState({unsur:[], catid:0});
      }else{
        this.setState({ loading: true });
        this.setState({expanded: ["c"+e], catid: e});
        fetchUnsur(e)
          .then(response => {
            this.props.pushUnsur(response.data);
            this.setState({ loading: false });
          })
          .catch(error => {
            console.log(error);
          });
      }

    }

    getUnsurSkala = (e)=>{

      if(this.state.ftid == e.featureTypeID.replace("@en", "")){
        if(this.state.ftidAct == true){
          this.setState({expanded:["c"+this.state.catid]});
        }else{
          this.setState({expanded:["c"+this.state.catid, "f"+e.featureTypeID.replace("@en", "")], ftid: e.featureTypeID.replace("@en", ""), ftidAct: true });
        }
      }else{
        this.setState({expanded:["c"+this.state.catid, "f"+e.featureTypeID.replace("@en", "")], ftid: e.featureTypeID.replace("@en", ""), ftidAct: true });
      }
    }

    renderUnsurx = (e)=>{

      let hsl =  _.filter(this.state.unsur, function(obj) {
        return _.includes(obj.typeName, e.typeName);
      });

      hsl = _.orderBy(hsl, 'code', 'asc'); // Use Lodash to sort array by 'name'

      return (
        <StyledTreeItem
          nodeId={"f"+e.featureTypeID.replace("@en", "")}
          label={e.typeName.replace("@en", "")}
          onClick={()=>{
            this.getUnsurSkala(e);
            this.setState({ftcode: e.code});
          }}
        >
            {hsl.map(this.renderUnsur)}
        </StyledTreeItem>
      )
    }

    renderItem = ()=>{
      return (
        <div>asd</div>
      )
    }

    handleCatDetail = ()=>{
      this.setState({openCat:true});
    }

    renderCat = (e) => {

      let b2i = _.uniqBy(this.state.unsur, 'typeName');

      let b2 = _.orderBy(b2i, 'typeName','asc');

      return (
          <StyledTreeItem
            nodeId={"c"+e.featureCatalogId.replace("@en", "")}
            label={
              <div>
                <span style = {{paddingRight:10}} onClick={()=>{this.getUnsur(e.featureCatalogId.replace("@en", ""))}}>
                  {e.name.replace("@en", "")}
                </span>
                <span  >
                  <a href = "#" onClick = {()=>{
                    this.setState({
                      openCat:true,
                      catSelected: e.featureCatalogId.replace("@en", ""),
                      catSelectedName: e.name.replace("@en", "")
                    });
                  }}>detail</a>
                </span>
              </div>
            }
            //endIcon = {CloseIcon}
            labelInfo="90"

          >

            {b2.map(this.renderUnsurx)}
          </StyledTreeItem>
      )
    }

    componentWillReceiveProps(nextProps){
      this.setState({category:nextProps.category});
      if(nextProps.unsur!=false){
        this.setState({unsur:nextProps.unsur});
      }
    }

    componentDidMount() {
      //console.log(this.state.category);
    }

    render(){
        const { open } = this.state;

        return(
          <AUX>
          <div className="sweet-loading">
            <BarLoader
              css={override}
              height={4}
              width={300}
              color={"#E8EAF6"}
              loading={this.state.loading}
            />
          </div>

          <Dialog
            open={this.state.openCat}
            fullWidth={false}

            maxWidth={""}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle disableTypography style = {{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
            >
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description" >

                <Alert severity="info"
                  action={
                      <IconButton onClick={this.handleCloseCat}>
                          <CloseIcon />
                      </IconButton>
                    }
                >
                  <Link to = "/">Beranda</Link> / Kugi / {this.state.catSelectedName}
                </Alert>

                  <Kugicatdetail id = {this.state.catSelected}/>

              </DialogContentText>
            </DialogContent>
          </Dialog>


          <Dialog
            open={this.state.open}
            fullWidth={false}
            fullScreen
            maxWidth={""}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >

            <DialogTitle disableTypography style = {{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
            >
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description" >
              <Paper style = {{padding:10}}>
              <Alert severity="info"
                action={
                  <span><a href= {`${ROOT_URL}featuretypegetbycode?code=${this.state.code}`} target="_blank">Akses API</a>
                    <IconButton onClick={this.handleClose}>
                        <CloseIcon />
                    </IconButton></span>
                  }
              ><Link to = "/">Beranda</Link> / {this.state.fcName} / {this.state.typeName}</Alert>

                <TableContainer  >
                  <Table aria-label="simple table">
                    <TableBody >
                        <TableRow key={1}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                            <b>Kode Unsur</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding: 2}}>{this.state.code}</TableCell>
                        </TableRow>
                        <TableRow key={2}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none",  padding:4}}>
                            <b>Nama Unsur</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none" ,  padding:2 }}>{this.state.typeName}</TableCell>
                        </TableRow>
                        <TableRow key={5}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                            <b>Katalog Unsur</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding:4}}>{this.state.featureCatalogue}</TableCell>
                        </TableRow>
                        <TableRow key={3}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                            <b>Definisi</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding:4}}>{this.state.definition}</TableCell>
                        </TableRow>
                        <TableRow key={4}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                            <b>Nama Alias</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding:4}}>{this.state.aliases}</TableCell>
                        </TableRow>
                        <TableRow key={6}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                            <b>Sumber Definisi</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding:4}}>{this.state.fcDefinitionSource}</TableCell>
                        </TableRow>
                        <TableRow key={8}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                             <b>Inheritance Sub type</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding:4}}>{this.state.inheritanceSubtype}</TableCell>
                        </TableRow>
                        <TableRow key={9}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                            <b>Inheritance Super type</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding:4}}>{this.state.inheritanceSupertype}</TableCell>
                        </TableRow>
                        <TableRow key={10}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                            <b>Inheritance Description</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding:4}}>{this.state.inheritanceDescription}</TableCell>
                        </TableRow>
                        <TableRow key={11}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                            <b>Inheritance Name</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding:4}}>{this.state.inheritanceName}</TableCell>
                        </TableRow>
                        <TableRow key={12}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                            <b>Referensi Definisi</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding:4}}>{this.state.fcDefinitionReference}</TableCell>
                        </TableRow>
                        <TableRow key={13}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                            <b>Abstrak</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding:4}}>{this.state.attributeIsAbstract}</TableCell>
                        </TableRow>
                        <TableRow key={14}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                            <b>Versi Katalog</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding:4}}>{this.state.attributVersionNumber}</TableCell>
                        </TableRow>

                        <TableRow key={16}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                            <b>Asosiasi Unsur</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding:4}}>{this.state.fcFeatureAssociation}</TableCell>
                        </TableRow>
                        <TableRow key={17}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                            <b>Association Role</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding:4}}>{this.state.fcAssociationRole}</TableCell>
                        </TableRow>
                        <TableRow key={18}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                            <b>Operasi Unsur</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding:4}}>{this.state.fcFeatureOperation}</TableCell>
                        </TableRow>
                        <TableRow key={19}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                            <b>Tahun Katalog</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding:4}}>{this.state.date}</TableCell>
                        </TableRow>

                        <TableRow key={20}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                            <b>Produsen Katalog</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding:4}}>{this.state.fcProducer}</TableCell>
                        </TableRow>
                        <TableRow key={21}>
                          <TableCell component="th" scope="row" style = {{borderBottom: "none", padding:4}}>
                            <b>Peran/Wewenang</b>
                          </TableCell>
                          <TableCell style = {{borderBottom: "none", padding:4}}>{this.state.role}</TableCell>
                        </TableRow>

                    </TableBody>
                  </Table>
              </TableContainer>
              </Paper>
              <br/>
              <TablePropertyType code = {this.state.code} fcid = {this.state.catid}/>
              </DialogContentText>
            </DialogContent>
          </Dialog>
            <section className="sections" style = {{paddingTop:"5%"}}>
              <div className="container">
                <div className="row justify-content-center" >

                {/*<Grid item xs={3}>
                  <Paper >
                    <Alert severity="warning">
                      Modul KUGI
                    </Alert>
                    <div  >
                      <center>
                      <img src = {"http://kugi.ina-sdi.or.id/webpage_kugi5/assets/user/images/index_kugi.png"} />

                       <p><b>Katalog Unsur Geografi Indonesia</b></p>
                      <Divider />
                      <div style = {{padding: "10px"}}><b>Browse: <a href = "http://kugi.ina-sdi.or.id/webpage_kugi5/kugi/kategori_kugi" target = "_blank">Data KUGI</a></b></div>
                      <Divider />
                      <br/>
                      <a target = "_blank" href = "http://kugi.ina-sdi.or.id/webpage_kugi5/assets/user/files/User_Guide_KUGI.pdf"><center><img src = {"http://kugi.ina-sdi.or.id/webpage_kugi5/assets/user/images/pdf.png"} /></center>
                      </a>Download User Manual

                      </center>
                    </div>
                  </Paper>
                </Grid>*/}
                <Grid item xs={12} style = {{paddingLeft:"10px"}}>
                  <Paper style ={{padding:10}}>
                  <Alert severity="info">
                    KUGI 5
                  </Alert>
                  <div style = {{padding:10}}>
                  <TreeView
                    defaultCollapseIcon={<FolderOpen />}
                    defaultExpandIcon={<FolderOpen />}
                    defaultEndIcon={<FolderOpen />}
                    expanded={this.state.expanded}
                  >
                    {this.state.category.map(this.renderCat)}
                  </TreeView>
                  </div>
                  </Paper>
                </Grid>
                  <div className="container">
                      <div className="row justify-content-center" id="counter"/>
                  </div>

                </div>
              </div>
            </section>
          </AUX>
        );
    }
}


const mapStatetoProps = state => {

    if (!state.unsur[0])
      state.unsur[0] = false;

    return {
        islight: state.ui_red.islight,
        category: state.category,
        unsur: state.unsur[0]
    };
}


export default connect(mapStatetoProps, {pushCategory, pushUnsur, pushSelectedUnsur})(Kugi);
